import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import IrregularCashCalculator from './IrregularCashCalculator';

const IrregularCashInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Irregular Cash Flow Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Irregular Cash Flow Calculator helps you analyze and manage your irregular income and expenses. It's perfect for freelancers, consultants, and anyone with inconsistent cash flows. Understanding your cash flow patterns can help you make better financial decisions and plan for the future.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Features</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Track irregular income sources</li>
        <li>Monitor variable expenses</li>
        <li>Analyze cash flow patterns</li>
        <li>Set financial goals</li>
        <li>Create budget plans</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator allows you to input your irregular income and expenses over a specified period. It then analyzes the data to provide insights into your cash flow patterns, helping you identify trends and make informed financial decisions.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Better financial planning</li>
        <li>Improved cash flow management</li>
        <li>Reduced financial stress</li>
        <li>Enhanced budgeting capabilities</li>
        <li>Smarter financial decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your irregular income and expenses, select the time period, and let the calculator do the rest. You'll receive a detailed analysis of your cash flow patterns, helping you make better financial decisions and plan for the future.</p>
    </div>
  );
};

const IrregularCash = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <IrregularCashCalculator/>
        </div>
        <IrregularCashInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default IrregularCash;